<template>
  <div class="page">
    <div class="container">
      <div class="mall-part">
        <!-- 导航栏 -->
        <div class="nav-bar">
          <!-- PC 端：面包屑导航 -->
          <div class="nav-title" v-if="!isMobile">
            <!-- <span @click="backHome" code-stm="event, PAGEURL, 返回首页">首页</span>
             >  -->
            <span @click="backHome" code-stm="event, PAGEURL, 返回品牌商城">品牌商城</span>
             >
            <span>{{ parentName }}</span>
          </div>
          <!-- 移动端：返回按钮 -->
          <div class="nav-back" v-else>
            <el-button
              class="nav-back-btn"
              @click="goBack"
              title="返回"
              aria-label="返回"
              type="text"
               code-stm="event, PAGEURL, 返回mob"
            >
              <i class="el-icon-arrow-left"></i>
              <span class="nav-back-text">返回</span>
            </el-button>
          </div>
        </div>

        <!-- Tabs栏 -->
        <el-tabs
          v-model="activeTab"
          @tab-click="handleTabClick"
          class="mall-tabs"
        >
          <el-tab-pane
            v-for="tab in tabs"
            :key="tab.catId"
            :label="tab.catName"
            :name="tab.catId"
          >
          </el-tab-pane>
        </el-tabs>

        <!-- 商品列表 -->
        <div class="product-list" v-loading="isLoading">
          <div
            v-for="item in mallList"
            :key="item.id"
            class="product-item"
            @click="handleProductClick(item)"
             code-stm="event, PAGEURL, 查看商品详情"
          >
            <div class="product-image">
              <img :src="item.mainImage" :alt="item.productName" />
            </div>
            <div class="product-title">{{ item.productName }}</div>
            <div class="product-price">
              <span class="product-points">
                <img
                  :src="
                    preText +
                    '/assets/~/media/images/activity/kiamall/pc/mall-icon-jifen.png'
                  "
                  alt=""
                />
                {{ formatPoints(item.pricePoints) }}</span
              >
              <span class="product-amount">
                <img
                  :src="
                    preText +
                    '/assets/~/media/images/activity/kiamall/pc/mall-icon-money.png'
                  "
                  alt=""
                />
                {{ formatCash(item.priceCash) }}</span
              >
            </div>
          </div>
        </div>
        <div class="more-btn" v-if="mallList.length > 0">
          <el-button
            v-if="!allLoaded"
            type="text"
            @click="loadMore"
            :loading="isLoading"
            code-stm="event, PAGEURL, 查看更多"
          >
            <i class="el-icon-arrow-down"></i
            >{{ isLoading ? "加载中..." : "加载更多" }}
          </el-button>
          <el-button v-else type="text" disabled> - 已加载全部 - </el-button>
        </div>
        <div class="no-data" v-if="mallList.length === 0">
          <el-empty description="暂无数据" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queUrl } from "@/config/base";

export default {
  name: "mallList",
  components: {
  },
  data() {
    return {
      parentId: "",
      parentName: "",
      activeTab: "",
      tabs: [],
      mallList: [],
      pageNum: 1,
      pageSize: 10, // 默认 PC 每页数量，移动端会在 mounted 中改为 6
      total: 0,
      allLoaded: false,
      isLoading: false,
      headers: {},
      preText: "https://www.kia.cn",
      isMobile: false,
    };
  },
  mounted() {
    if (!window.location.href.includes("https://www.kia.cn")) {
      this.preText = "https://uat.kia.cn";
    } else {
      this.preText = "https://www.kia.cn";
    }
    // 判断是否为移动端（宽度或 UA）
    const ua = navigator.userAgent || "";
    this.isMobile =
      window.innerWidth <= 768 ||
      /Mobile|Android|iP(hone|od|ad)/i.test(ua);
    // 移动端每页展示 6 条
    if (this.isMobile) {
      this.pageSize = 6;
    }
    // 获取URL参数
    this.parentId = this.$route.query.parentId || "";
    this.parentName = this.$route.query.parentName || "";

    // 初始化 headers
    this.headers = {
      Token: "a5764a961abc48e28067bd5a8b69c61e", // 测试token，实际应该从登录信息获取
    };

    // 获取tabs列表
    this.getTabsList();
    // 获取商品列表
    this.getMallList();
  },
  activated() {
    // 从 AW2025 页面（带 forceRefresh 标记）进入列表时，强制按当前路由参数刷新列表
    const needsForceRefresh = String(this.$route.query.forceRefresh || "") === "1";
    if (!needsForceRefresh) return;

    this.parentId = this.$route.query.parentId || "";
    this.parentName = this.$route.query.parentName || "";

    this.pageNum = 1;
    this.mallList = [];
    this.allLoaded = false;
    this.tabs = [];
    this.activeTab = "";

    this.getTabsList();
    this.getMallList(true);

    // 刷新完成后，清理 URL 中的 forceRefresh 标记，避免后续浏览器返回时再次触发刷新
    const cleanedQuery = { ...this.$route.query };
    delete cleanedQuery.forceRefresh;
    this.$nextTick(() => {
      this.$router.replace({
        name: this.$route.name || "mallList",
        query: cleanedQuery,
      });
    });
  },
  methods: {
    // Header-co 会 emit forbid/open；这里做兜底，避免触发时报错
    forbid() {},
    open() {},
    goBack() {
      if (this.$router && typeof this.$router.back === "function") {
        this.$router.back();
      } else if (this.$router && typeof this.$router.go === "function") {
        this.$router.go(-1);
      }
    },
    backHome() {
      // 关闭所有历史页面，跳转到首页
      this.$router.replace({ path: '/' });
    },
    backList() {
      // 关闭所有历史页面，跳转到 mallList
      this.$router.replace({ path: '/mallList' });
    },
    // 获取tabs列表
    getTabsList() {
      if (!this.parentId) {
        // 如果没有parentId，设置默认tabs
        this.tabs = [{ catId: "all", catName: "全部" }];
        this.activeTab = "all";
        return;
      }

      this.$axios
        .get(`${queUrl}api/shop/product/api/secondLevelList`, {
          params: {
            parentId: this.parentId,
            status: 0,
          },
          headers: this.headers,
        })
        .then((res) => {
          if (res.data.code == 200) {
            const list = res.data.rows || [];
            // 将 catId 转换为字符串类型（Element UI 的 name 属性需要字符串）
            const formattedList = list.map((item) => ({
              ...item,
              catId: String(item.catId || ""),
            }));
            // 添加"全部"选项
            this.tabs = [{ catId: "all", catName: "全部" }, ...formattedList];
            // 设置默认选中第一个（使用 catId）
            this.activeTab = String(this.tabs[0].catId);
          } else {
            this.$message.error(res.data.message || "获取分类列表失败");
            // 失败时设置默认tabs
            this.tabs = [{ catId: "all", catName: "全部" }];
            this.activeTab = "all";
          }
        })
        .catch((err) => {
          console.error("获取tabs列表失败:", err);
          this.$message.error("获取分类列表失败");
          // 失败时设置默认tabs
          this.tabs = [{ catId: "all", catName: "全部" }];
          this.activeTab = "all";
        });
    },
    // 获取商品列表
    getMallList(isReset = false) {
      if (this.isLoading) return;

      if (isReset) {
        this.pageNum = 1;
        this.mallList = [];
        this.allLoaded = false;
      }

      this.isLoading = true;

      // 获取当前选中的tab（activeTab 存储的是 catId，字符串类型）
      const currentTab = this.tabs.find(
        (tab) => String(tab.catId) === String(this.activeTab)
      );
      const subCategoryId = currentTab ? String(currentTab.catId) : "";

      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: '0'
      };

      // 如果有parentId，添加到参数中
      if (this.parentId) {
        params.categoryId = this.parentId;
      }

      // 如果选中的不是"全部"，添加分类id（使用 catId）
      if (subCategoryId && subCategoryId !== "all") {
        params.subCategoryId = subCategoryId;
      }

      this.$axios
        .get(`${queUrl}api/shop/product/apilist`, {
          params: params,
          headers: this.headers,
        })
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.total = res.data.total || 0;
            const rows = res.data.rows;

            if (isReset) {
              this.mallList = rows;
            } else {
              this.mallList = this.mallList.concat(rows);
            }

            // 如果返回的数据少于 pageSize，说明没有更多了
            if (!Array.isArray(rows) || rows.length < this.pageSize || this.total == this.pageSize || this.mallList.length === this.total) {
              this.allLoaded = true;
            } else {
              this.pageNum += 1;
            }
          } else {
            this.$message.error(res.data.message || "获取商品列表失败");
          }
        })
        .catch((err) => {
          console.error("获取商品列表失败:", err);
          this.$message.error("获取商品列表失败");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 加载更多
    loadMore() {
      if (this.isLoading || this.allLoaded) return;
      this.getMallList(false);
    },
    handleTabClick(tab) {
      // 切换tab时重新加载数据
      this.getMallList(true);
    },
    handleProductClick(item) {
      // 点击商品跳转到详情页
      if (item && item.productId) {

        if (this.isMobile) {
        const productLink =item.productLink
        if (productLink) {
          window.location.href = productLink;
        } else {
          this.$message.error("暂未配置商品链接");
        }
        return;
      }
        this.$router.push({
          path: "/mall/detail",
          query: {
            id: item.productId,
          },
        });
      } else {
        this.$message.error("商品信息不完整");
      }
    },
    // 千分位格式化
    formatThousand(value, keepDecimals = false) {
      if (value === null || value === undefined || value === "") {
        return keepDecimals ? "0.00" : "0";
      }
      const num = Number(value);
      if (isNaN(num)) {
        return String(value);
      }
      const fixedStr = keepDecimals
        ? num.toFixed(2)
        : Math.floor(num).toString();
      const parts = fixedStr.split(".");
      const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.length > 1 ? `${intPart}.${parts[1]}` : intPart;
    },
    formatPoints(value) {
      return this.formatThousand(value, false);
    },
    formatCash(value) {
      return this.formatThousand(value, true);
    },
    getDefaultImage() {
      // 默认占位图
      return "https://via.placeholder.com/200x200?text=商品图片";
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  background-color: #fff;
}

.container {
  min-height: 100vh;
  display: flex;
  @media (min-width: 768px) {
    padding: calc(78 / 1920 * 100vw) 0;
    width: calc(1308 / 1920 * 100vw);
    margin: 0 auto;
  }
  @media (max-width: 768px) { /* 移动端 */
    padding: 60px 0 calc(60 / 750 * 100vw);
    width: 100%;
    margin: 0 auto;
  }
}

.mall-part {
  width: 100%;
  background: #fff;
  @media (min-width: 768px) {
    padding-top: calc(24 / 1920 * 100vw);
  }
  @media (max-width: 768px) { /* 移动端 */
    padding-top: calc(70 / 1920 * 100vw);
  }
}

// 导航栏
.nav-bar {
  @media (min-width: 768px) {
    padding: calc(20 / 1920 * 100vw) 0;
  }
  @media (max-width: 768px) { /* 移动端 */
    .nav-title {
      display: none;
    }
    .nav-back {
      display: flex;
      align-items: center;
      padding: calc(20 / 750 * 100vw) calc(30 / 750 * 100vw);
      background-color: #fff;
    }
  }
  .nav-title {
    font-family: "KiaSignatureRegular", "方正兰亭", "Helvetica Neue", Helvetica,
      Arial, sans-serif;
    font-size: calc(16 / 1920 * 100vw);
    font-weight: 500;
    color: #b9b9b9;
    cursor: pointer;
    span {
      display: inline-block;
      color: #000;
      margin-left: calc(4 / 1920 * 100vw);
      margin-right: calc(4 / 1920 * 100vw);
    }
    @media (min-width: 768px) {
      //   font-size: calc(28 / 1920 * 100vw);
    }
    @media (min-width: 1614px) {
      //   font-size: 22px;
    }
  }
}

.nav-back-btn {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0;
  border: none;
  color: #000;
  font-family: "FZLanTingHeiS-R-GB";
  .el-icon-arrow-left {
    font-size: calc(32 / 750 * 100vw);
    margin-right: calc(8 / 750 * 100vw);
  }
  .nav-back-text {
    font-size: calc(28 / 750 * 100vw);
  }
}

// Tabs栏
.mall-tabs {
  margin-top: 20px;
  @media (min-width: 768px) {
    margin-top: calc(30 / 1920 * 100vw);
  }
  @media (max-width: 768px) { /* 移动端 */
    margin-top: calc(70 / 1920 * 100vw);
    box-sizing: border-box;
    padding-left: calc(60 / 1920 * 100vw);
  }
  ::v-deep .el-tabs__header {
    margin-bottom: 20px;
    border-bottom: none;
    @media (min-width: 768px) {
      margin-bottom: calc(30 / 1920 * 100vw);
    }
  }
  ::v-deep .el-tabs__nav-wrap::after {
    display: none;
  }
  // 移动端 tabs 支持左右滑动
  @media (max-width: 768px) {
    // 隐藏左右箭头按钮
    ::v-deep .el-tabs__nav-prev,
    ::v-deep .el-tabs__nav-next {
      display: none !important;
    }

    // 确保 nav-wrap 可以滚动
    ::v-deep .el-tabs__nav-wrap {
      overflow: hidden;
    }
    ::v-deep .el-tabs__nav-wrap .el-tabs__nav-scroll {
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      &::-webkit-scrollbar {
        display: none;
      }
      // 隐藏滚动条但保持滚动功能
      scrollbar-width: none; // Firefox
      -ms-overflow-style: none; // IE 和 Edge

    }

    // nav 容器支持水平滚动
    ::v-deep .el-tabs__nav {
      // overflow-x: auto !important;
      // overflow-y: hidden !important;
      // -webkit-overflow-scrolling: touch;
      // white-space: nowrap;
      // scroll-behavior: smooth;
      transform: translateX(0) !important;
      &::-webkit-scrollbar {
        display: none;
      }
      // 隐藏滚动条但保持滚动功能
      scrollbar-width: none; // Firefox
      -ms-overflow-style: none; // IE 和 Edge
    }

    // 允许水平拖动滚动
    ::v-deep .el-tabs__header {
      user-select: none;
      -webkit-user-select: none;
      touch-action: pan-x; // 允许水平滚动
      cursor: grab;
      &:active {
        cursor: grabbing;
      }
    }

    // tab 项不换行
    ::v-deep .el-tabs__item {
      white-space: nowrap;
      flex-shrink: 0;
    }
  }
  ::v-deep .el-tabs__item {
    font-family: "FZLanTingHeiS-R-GB";

    color: #a7a7a7;
    @media (min-width: 768px) {
      font-size: calc(22 / 1920 * 100vw);
      padding: 0 calc(20 / 1920 * 100vw);
    }
    @media (max-width: 768px) { /* 移动端 */
      font-size: calc(29 / 750 * 100vw);
    }
  }
  ::v-deep .el-tabs__active-bar {
    display: none;
  }
  ::v-deep .el-tabs__item {
    transition: all 0.3s;
    &:hover {
      color: #000;
    }
  }
  ::v-deep .el-tabs__item.is-active {
    color: #000;
    font-weight: 600;
    position: relative;
  }
}

// 商品列表
.product-list {
  display: flex;
  flex-wrap: wrap;
  @media (min-width: 768px) {
    gap: calc(20 / 1920 * 100vw);
    margin: 0 calc(-10 / 1920 * 100vw);
  }
  @media (min-width: 1614px) {
    gap: 20px;
    margin: 0 -10px;
  }
  @media (max-width: 768px) { /* 移动端 */
    padding: 0 calc(20 / 750 * 100vw);
  }

  .product-item {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: transform 0.2s;
    // 移动端：一行 2 个
    @media (max-width: 768px) {
      flex: 0 0 50%;
      width: 50%;
      padding: 0 calc(20 / 750 * 100vw);
      margin-bottom: calc(30 / 750 * 100vw);
      box-sizing: border-box;
    }
    @media (min-width: 768px) {
      flex: 0 0 calc(20% - calc(16 / 1920 * 100vw));
      width: calc(20% - calc(16 / 1920 * 100vw));
      margin-bottom: calc(30 / 1920 * 100vw);
      padding: 0 calc(10 / 1920 * 100vw);
    }
    @media (min-width: 1614px) {
      flex: 0 0 calc(20% - 16px);
      width: calc(20% - 16px);
      margin-bottom: 24px;
      padding: 0 10px;
    }

    .product-image {
      width: 100%;
      aspect-ratio: 1;
      overflow: hidden;
      background-color: #f5f5f5;
      margin-bottom: calc(22 / 1920 * 100vw);
      @media (min-width: 768px) {
        margin-bottom: calc(12 / 1920 * 100vw);
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .product-title {
      font-family: "FZLanTingHeiS-R-GB";
      font-size: calc(17 / 1920 * 100vw);
      color: #000;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      line-clamp: 1;
      -webkit-box-orient: vertical;
      @media (min-width: 768px) {
        font-size: calc(16 / 1920 * 100vw);
        margin-bottom: calc(8 / 1920 * 100vw);
        padding-left: calc(4 / 1920 * 100vw);
        line-height: calc(26 / 1920 * 100vw);
        margin-bottom: calc(27 / 1920 * 100vw);
      }
      @media (min-width: 1614px) {
        // font-size: 13px;
        // margin-bottom: 6px;
      }
      @media (max-width: 768px) { /* 移动端 */
        font-size: calc(25 / 750 * 100vw);
        margin-top: calc(37 / 750 * 100vw);
        margin-bottom: calc(10 / 750 * 100vw);

      }
    }

    .product-price {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: "FZLanTingHeiS-R-GB";

      .product-points {
        flex: 1;
        font-size: calc(16 / 1920 * 100vw);
        color: #000000b2;
        img {
          width: calc(14 / 1920 * 100vw);
          height: auto;
          margin-right: calc(4 / 1920 * 100vw);
          vertical-align: text-top;
        }
        @media (min-width: 768px) {
          font-size: calc(14 / 1920 * 100vw);
        }
        @media (min-width: 1614px) {
          font-size: calc(14 / 1920 * 100vw);
        }
        @media (max-width: 768px) { /* 移动端 */
          font-size: calc(27 / 750 * 100vw);
          margin-bottom: calc(10 / 750 * 100vw);
          color: #000;
          img {
            width: calc(24 / 750 * 100vw);
          }

        }
      }

      .product-amount {
        flex: 1;
        font-size: calc(16 / 1920 * 100vw);
        color: #000000b2;
        font-weight: 500;
        img {
          width: auto;
          height: calc(15 / 1920 * 100vw);
          margin-right: calc(4 / 1920 * 100vw);
          vertical-align: text-top;
        }
        @media (min-width: 768px) {
          font-size: calc(16 / 1920 * 100vw);
        }
        @media (min-width: 1614px) {
          ont-size: calc(16 / 1920 * 100vw);
        }
        @media (max-width: 768px) { /* 移动端 */
          font-size: calc(27 / 750 * 100vw);
          margin-bottom: calc(10 / 750 * 100vw);
          color: #000;
          img {
            height: calc(24 / 750 * 100vw);
          }

        }
      }
    }
  }
}
.more-btn {
  width: 100%;
  text-align: center;
  margin-top: calc(60 / 1920 * 100vw);

  .el-button {
    font-family: "FZLanTingHeiS-R-GB";
    color: #00000080;
    font-size: calc(20 / 1920 * 100vw);
    font-weight: 300;
    i {
      font-size: calc(20 / 1920 * 100vw);
      margin-right: calc(4 / 1920 * 100vw);
    }
    @media (max-width: 768px) { /* 移动端 */
      font-size: calc(32 / 750 * 100vw);
      i {
        font-size: calc(32 / 750 * 100vw);
      }
    }
  }
}
</style>
